import React from "react";
import {APP_EXTERNAL_URLS} from "../../../constants/AppGlobal";

import './LoginToolbarView.scss';
import {hasGtmEnabled} from "../../../helpers/AppHelper";

export default class LoginToolbarView extends React.Component {
    onButtonClick = () => {
        window.location.href = "/";
    }
    getSignupUrl = () => {
        if (hasGtmEnabled()) {
            return APP_EXTERNAL_URLS.NOT_LOGGED_PLANS_PAGE;
        }

        return APP_EXTERNAL_URLS.SIGN_UP;
    }
    render() {
        return (
            <div className="loginToolbar">
                <div className="logoContainer">
                    <button title="WeVideo" onClick={this.onButtonClick} />
                </div>
                <a href={this.getSignupUrl()} className="loginButton">
                    Sign Up
                </a>
            </div>
        )
    }
}